var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFluskLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.07692C0 1.37759 1.37759 0 3.07692 0H9.53846C11.2378 0 12.6154 1.37759 12.6154 3.07692V28.9231C12.6154 30.6224 11.2378 32 9.53846 32H3.07692C1.37759 32 0 30.6224 0 28.9231V3.07692Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.07692 12.6154C1.37759 12.6154 0 11.2378 0 9.53846V3.07692C0 1.37759 1.37759 0 3.07692 0H28.9231C30.6224 0 32 1.37759 32 3.07692V9.53846C32 11.2378 30.6224 12.6154 28.9231 12.6154H3.07692Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0769 28.9231C17.3776 28.9231 16 27.5455 16 25.8462V19.3846C16 17.6853 17.3776 16.3077 19.0769 16.3077H25.5385C27.2378 16.3077 28.6154 17.6853 28.6154 19.3846V25.8462C28.6154 27.5455 27.2378 28.9231 25.5385 28.9231H19.0769Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6154 15.5385V18.4615H9.69231V9.53846H23.3846V12.6154H15.6923C14 12.6154 12.6154 14 12.6154 15.5385Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluskLogo);
export default __webpack_public_path__ + "static/media/flusk-logo.c80dcae6935d64375ccb11234209926a.svg";
export { ForwardRef as ReactComponent };